//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from "@api/manage";
export default {
  name: 'CarPushModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '车牌识别表单',
      tableName: 'ai_car_push',
      form_fields: ['deviceId', 'plateCode', 'score', 'srcId', 'aiCarType', 'userId', 'carId'],
      form_fields_time: [],
      validatorRules: {
        deviceId: {
          rules: [{
            required: true,
            message: '请输入设备id!'
          }]
        }
      },
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view/',
        queryCarCards: '/ea/asset/car/queryCarCards'
      },
      carCardsList: [],
      //车牌号
      modalName: '图片',
      // 是否显示图片
      showImgModal: false,
      ImgModaUrl: ''
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loadCarCard();
  },
  methods: {
    getAvatarView: function getAvatarView(srcId) {
      return this.url.imgerver + srcId;
    },
    // 加载车牌号
    loadCarCard: function loadCarCard() {
      var that = this;
      that.carCardsList = [];
      getAction(this.url.queryCarCards).then(function (res) {
        if (res.success) {
          that.carCardsList = res.result;
        }
      });
    },
    // 图片关闭
    setModal1Visible: function setModal1Visible() {
      this.showImgModal = false;
    },
    // 图片打开
    detail: function detail() {
      this.ImgModaUrl = this.getAvatarView(this.model.srcId);
      this.showImgModal = true;
    },
    handleOk: function handleOk() {
      var _this = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          var httpurl = '',
              method = '';

          if (!_this.model.plateCode) {
            httpurl = _this.url.add ? _this.url.add : _this.pagePath;
            method = 'post';
          } else {
            httpurl = _this.url.edit ? _this.url.edit : _this.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this.$message_custom(res.message);

              that.$emit('ok');
              that.close();
            } else {
              _this.$message_custom(res.message, 'warning');
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};